import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export const ConfirmDialog = (props) => {
  const {
    open,
    handleClose,
    message,
    OK = 'OK',
    Cancel = 'Cancel',
    ...rests
  } = props;
  //const [open, setOpen] = React.useState(false);

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="confirm-dialog-title"
        aria-describedby="confirm-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="confirm-dialog-title">{'ยืนยัน'}</DialogTitle>
        <DialogContent>
          <DialogContentText id="confirm-dialog-description">
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ textTransform: 'none' }}
            onClick={() => handleClose(false)}
            variant="contained"
          >
            {Cancel}
          </Button>
          <Button
            onClick={() => handleClose(true)}
            variant="contained"
            color="primary"
            autoFocus
            style={{ textTransform: 'none' }}
            {...rests}
          >
            {OK}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
